// Aviso de imutabilidade: assinaturas e seguros apontam para a configuração,
// então ela não é editável — mudar a regra é criar uma nova.
import { LockIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"

const prefix = "pages.paymentConfigurations"

interface ImmutabilityNoticeProps {
  className?: string
}

export const ImmutabilityNotice = ({
  className,
}: ImmutabilityNoticeProps) => {
  const { t } = useTranslation()
  return (
    <div
      className={cn(
        "flex items-start gap-3 rounded-xl border border-blue-200 bg-blue-50 p-4 text-blue-800",
        className
      )}
    >
      <LockIcon
        className="mt-0.5 h-4 w-4 shrink-0"
        aria-hidden="true"
      />
      <div className="space-y-0.5">
        <p className="text-sm font-semibold">
          {t(`${prefix}.immutable.title`)}
        </p>
        <p className="text-xs leading-relaxed">
          {t(`${prefix}.immutable.description`)}
        </p>
      </div>
    </div>
  )
}
